(() => {
  const root = document.querySelector('[data-plaid-lower]');
  if (!root) return;
  const quality = root.querySelector('[data-plaid-quality]');
  if (quality) {
    const image = quality.querySelector('[data-plaid-quality-image]');
    let sources = [];
    try { sources = JSON.parse(quality.querySelector('[data-plaid-quality-images]').textContent); } catch {}
    const updateImage = (color) => {
      const source = sources.find((item) => item.color === color);
      if (source && image.getAttribute('src') !== source.src) image.src = source.src;
    };
    updateImage(document.querySelector('[data-plaid-color][aria-pressed="true"]')?.dataset.plaidColor);
    document.addEventListener('plaid:variant-change', (event) => updateImage(event.detail?.color));
  }
  const reviewLink = document.querySelector('[data-plaid-review-link]');
  const reviews = root.querySelector('#plaid-reviews');
  if (!reviewLink || !reviews) return;
  reviewLink.setAttribute('href', '#plaid-reviews');
})();
